<template>
  <div>
    <GoogleRecaptcha ref="recaptchaRef"></GoogleRecaptcha>  
    <div v-if="exibirResultado">
      <b-card
        v-if="tabela.itens.length > 0"
        no-body
        class="p-2"
        bg-variant="light"
      >
        <b-row class="mb-1">
          <b-col>
            <b-form class="float-left ml-2 mt-1" inline>
              <label
                style="font-size: 0.875rem"
                class="mr-sm-1"
                for="inline-form-custom-select-pref"
                >Exibir</label
              >
              <b-form-select
                id="inline-form-custom-select-pref"
                class="mb-2 mr-sm-2 mb-sm-0"
                size="sm"
                v-model="paginacao.per_page"
              >
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="30">30</option>
                <option :value="40">40</option>
                <option :value="50">50</option>
              </b-form-select>
              <label style="font-size: 0.875rem">linhas</label>
            </b-form>
          </b-col>
          <b-col class="mt-1">
            <b-button @click="excel()" size="sm" pill variant="outline-secondary">
              <font-awesome-icon
                :icon="['far', 'file-excel']"
                title="Exportar resultado em Excel"
                size="lg"
              />
              Exportar Excel
            </b-button>
          </b-col>
          <b-col sm="7" class="mr-2">
            <b-form-group
              label="Ordenar por"
              label-for="sort-by-select"
              label-cols-sm="4"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  class="w-75"
                  @change="ordenar()"
                >
                  <template #first>
                    <option value=""></option>
                  </template>
                </b-form-select>

                <b-form-select
                  size="sm"
                  class="w-25"
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  @change="ordenar()"
                >
                  <option :value="false">Crescente</option>
                  <option :value="true">Decrescente</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
      <b-table
        small
        show-empty
        borderless
        thead-class="hidden-header"
        :no-border-collapse="false"
        :items="tabela.itens"
        :fields="tabela.campos"
        :per-page="paginacao.per_page"
        :current-page="paginacao.current_page"
        id="my-table"
      >
        <template #empty>
          <b-alert variant="warning" :show="carregado">
            <h6 class="text-dark text-center" style="font-size: 16px">
              <b-icon-exclamation-circle-fill
                class="mr-1"
              ></b-icon-exclamation-circle-fill>
              Nenhuma multa encontrada que conste em aberto e/ou recente.
              Verifique os filtros ou avalie utilizar a
              <strong>Busca Avançada</strong> para o caso de multa cancelada. Se
              necessário, verifique no site do DETRAN:
              <b-link
                class="text-primary"
                target="_blank"
                href="https://www.detran.mg.gov.br"
                ><strong>https:www.detran.mg.gov.br</strong></b-link
              >
            </h6>
          </b-alert>
        </template>
        <template v-slot:cell(result)="data">
          <b-card style="font-size: small" class="mb-2 shadow border-white">
            <b-alert :show="data.item.showAlert" variant="danger" dismissible>
              <h6 class="alert-heading">
                <b-icon-exclamation-circle-fill
                  variant="danger"
                ></b-icon-exclamation-circle-fill>
                Não foi possível gerar guia de pagamento para o auto de infração
                de trânsito: {{ data.item.num_ait_composto }}
              </h6>
              <p>
                Entre em contato ou utilize uma das seguintes alternativas para
                emissão da guia da pagamento :
              </p>
              <ul>
                <li>
                  <b-link
                    target="_blank"
                    class="text-primary"
                    href="https://servicos.pbh.gov.br/servicos/i/5fdb7b00bbfc827e9ece9aea/5dc8470253fd6b5bbd99185f/servicos%2Bguias-multa-de-transito-nao-inscritas-em-divida-ativa"
                    >Guias - Multa de Trânsito - Não Inscritas em Dívida
                    Ativa</b-link
                  >
                </li>
                <li>
                  <b-link
                    target="_blank"
                    class="text-primary"
                    href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/emitir-de-extrato-de-multas"
                    >DETRAN - MG - Emitir Boleto de Multa</b-link
                  >
                </li>
              </ul>
            </b-alert>
            <b-row>
              <b-col v-if="exibirPlaca">
                <b-form-group
                  label="Placa"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span style="font-weight: 500">
                    {{ data.item.placa_veiculo }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Data Infração"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span style="font-weight: 500">
                    {{ obterDataFormatoBrasil(data.item.data_infracao) }}
                    {{ data.item.hora_infracao }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label-size="sm" label-class="text-secondary">
                  <template slot="label"
                    ><span>Número AIT&nbsp;</span
                    ><b-icon
                      v-b-tooltip.hover
                      title="AIT - Auto de Infração de Trânsito"
                      class="text-dark"
                      icon="question-circle-fill"
                    ></b-icon
                  ></template>
                  <span style="font-weight: bold">
                    {{ data.item.num_ait_composto }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Convertida em Advertência?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    class="text-danger"
                    v-if="data.item.ind_convertido == 1"
                    >Sim</span
                  >
                  <span style="font-weight: 500" v-else>Não</span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Quitada?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    :class="
                      ` text-` + getVariantStatus(data.item.ind_multa_quitada)
                    "
                  >
                    {{ obterStatusSimNao(data.item.ind_multa_quitada) }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Suspensa?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    :class="
                      ` text-` + getVariantStatus(!data.item.ind_multa_suspensa)
                    "
                  >
                    {{ obterStatusSimNao(data.item.ind_multa_suspensa) }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Dívida Ativa?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    :class="
                      ` text-` +
                      getVariantStatus(!data.item.ind_multa_divida_ativa)
                    "
                  >
                    {{ obterStatusSimNao(data.item.ind_multa_divida_ativa) }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Prescrita?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    :class="
                      ` text-` + getVariantStatus(!data.item.ind_multa_prescrita)
                    "
                  >
                    {{ obterStatusSimNao(data.item.ind_multa_prescrita) }}
                  </span>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Cancelada?"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span
                    style="font-weight: 500"
                    class="text-danger"
                    v-if="data.item.ind_cancelado == 1"
                    >Sim</span
                  >
                  <span style="font-weight: 500" v-else>Não</span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="9">
                <b-form-group
                  label="Infração"
                  label-size="sm"
                  label-class="text-secondary"
                >
                  <span style="font-weight: 500">
                    {{
                      data.item.codigo_infracao +
                      "-" +
                      data.item.descricao_infracao_completa
                    }}
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1 text-center">
              <b-col>
                <b-link
                  @click="exibirInfo(data)"
                >
                  <font-awesome-icon
                    v-if="!data.item.exibirInfo"
                    :icon="['fa', 'angles-down']"
                    title="Visualizar mais informações"
                    size="lg"
                    class="mr-2 text-dark"
                  />
                  <span v-if="!data.item.exibirInfo">Mais informações</span>
                </b-link>
              </b-col>
            </b-row>
            <b-collapse :id="`info-` + data.index" v-model="data.item.exibirInfo">
              <hr />
              <b-overlay :show="data.item.showmanowanderley"  rounded="sm">
                <b-row>
                  <b-col sm="4">
                    <b-form-group
                      label="Local da Infração"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span> {{ data.item.local_infracao_completo }}</span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" v-if="!data.item.ind_cancelado">
                    <b-form-group
                      label="Prazo Entrada de Defesa de Autuação"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.prazo_defesa">
                        {{ obterDataFormatoBrasil(data.item.prazo_defesa) }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" v-if="!data.item.ind_cancelado">
                    <b-form-group label-size="sm" label-class="text-secondary ">
                      <template slot="label"
                        ><span
                          >Prazo Identificação Condutor Infrator -
                          FICI&nbsp;</span
                        ><b-icon
                          v-b-tooltip.hover
                          title="FICI - Identificação do Condutor Infrator"
                          class="text-dark"
                          icon="question-circle-fill"
                        ></b-icon
                      ></template>
                      <span v-if="data.item.prazo_fici">
                        {{ obterDataFormatoBrasil(data.item.prazo_fici) }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="!data.item.ind_cancelado">
                  <b-col sm="4" v-if="data.item.nap">
                    <b-form-group
                      label="Prazo Vencimento Pagamento com Desconto"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.prazo_recurso_jari">
                        {{ obterDataFormatoBrasil(data.item.prazo_recurso_jari) }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" v-if="data.item.nap">
                    <b-form-group label-size="sm" label-class="text-secondary ">
                      <template slot="label"
                        ><span>Prazo Entrada de Recurso JARI&nbsp;</span
                        ><b-icon
                          v-b-tooltip.hover
                          title="JARI - Junta Administrativa de Recursos de Infrações"
                          class="text-dark"
                          icon="question-circle-fill"
                        ></b-icon
                      ></template>
                      <span v-if="data.item.prazo_recurso_jari">
                        {{ obterDataFormatoBrasil(data.item.prazo_recurso_jari) }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" v-if="data.item.nap">
                    <b-form-group label-size="sm" label-class="text-secondary ">
                      <template slot="label"
                        ><span>Prazo Entrada de Recurso CETRAN&nbsp;</span
                        ><b-icon
                          v-b-tooltip.hover
                          title="CETRAN - Conselho Estadual de Trânsito"
                          class="text-dark"
                          icon="question-circle-fill"
                        ></b-icon
                      ></template>
                      <span v-if="data.item.prazo_recurso_cetran">
                        {{
                          obterDataFormatoBrasil(
                            data.item.prazo_recurso_cetran
                          )
                        }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group
                      label="Notificação de Autuação"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.nit">
                        {{ data.item.nit }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group
                      label="Notificação de Penalidade"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.nap">
                        {{ data.item.nap }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group
                      label="Número de Processamento"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.numero_processamento_sram">
                        {{ data.item.numero_processamento_sram }}
                      </span>
                      <span v-else> - </span>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group
                      label="Código Lançamento"
                      label-size="sm"
                      label-class="text-secondary "
                    >
                      <span v-if="data.item.codigo_lancamento_siatu">
                        {{ data.item.codigo_lancamento_siatu }}
                      </span>
                      <span v-else align="center"> - </span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="text-center">
                  <b-col>
                    <b-link
                      @click="exibirInfo(data)"
                    >
                      <font-awesome-icon
                        :icon="['fa', 'angles-up']"
                        size="lg"
                        class="text-dark"
                      />
                    </b-link>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-collapse>
            <template v-slot:footer>
              <b-row>
                <b-col align="right">
                  <b-button-group size="sm">
                    <b-button v-if="exibirBtnGuia(data)" pill class="mr-2" variant="outline-secondary" @click.prevent="emitirGuia(data)">
                      <font-awesome-icon
                        :icon="['fas', 'download']"
                        title="Emitir guia de pagamento"
                        size="lg"
                      />
                      Guia de Pagamento (DRAM)
                    </b-button>
                    <b-button
                      pill
                      variant="primary"
                      @click.prevent="visualizar(data)"
                    >
                      <font-awesome-icon
                        :icon="['fas', 'eye']"
                        title="Visualizar o registro"
                        size="lg"
                      />
                      Ver Dados Completos
                    </b-button>
                  </b-button-group>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </template>
      </b-table>
      <hr />
      <div v-if="tabela.itens.length > 0" class="float-left">
        <b-row>
          <b-col>
            <p>
              Listando registros de <strong>{{ registroInicialPagina }}</strong> a
              <strong>{{ registroFinalPagina }}</strong> de
              <strong>{{ paginacao.total }}</strong>
            </p>
          </b-col>
        </b-row>
      </div>
      <div v-if="tabela.itens.length > 0" class="float-right">
        <b-pagination
          size="sm"
          v-model="paginacao.current_page"
          :total-rows="paginacao.total"
          :per-page="paginacao.per_page"
          aria-controls="my-table"
        >
        </b-pagination>
      </div>
    </div>
  </div>  
</template>

<script>
import FiltroMulta from "@/models/FiltroMulta.js";
import Paginacao from "@/models/Paginacao.js";
import Ordenacao from "@/models/Ordenacao.js";
import { helperDatas } from "@/helpers/datas.js";
import moment from "moment";
import helpers from "@/helpers";
import { mapMutations, mapGetters } from "vuex";
import GoogleRecaptcha from "@/components/GoogleRecaptcha.vue";

export default {
  components: {
    GoogleRecaptcha,
  },  
  props: {
    filtro: { type: FiltroMulta, default: () => new FiltroMulta() },
    exibirResultado: { type: Boolean, default: () => false },
    exibirPlaca: { type: Boolean, default: () => false },
  },
  data() {
    return {      
      tabela: {
        campos: [
          {
            key: "result",
            label: "",
          },
        ],
        itens: [],
      },
      paginacao: new Paginacao(),
      ordenacao: new Ordenacao(),
      sortBy: "",
      sortDesc: false,
      sortOptions: [
        {
          value: "data_infracao",
          text: "Data Infração",
        },
        {
          value: "num_ait_composto",
          text: "Nº AIT",
        },
        {
          value: "ind_multa_quitada",
          text: "Quitada?",
        },
        {
          value: "ind_multa_suspensa",
          text: "Suspensa?",
        },
        {
          value: "ind_multa_divida_ativa",
          text: "Dívida Ativa?",
        },
        {
          value: "ind_multa_prescrita",
          text: "Prescrita?",
        },
        {
          value: "ind_cancelado",
          text: "Cancelada?",
        },
        {
          value: "infracao",
          text: "Infração",
        },
      ],
      carregado: false,
    };
  },

  computed: {
    registroInicialPagina() {
      return (this.paginacao.current_page - 1) * this.paginacao.per_page + 1;
    },

    registroFinalPagina() {
      let regFinal = this.paginacao.current_page * this.paginacao.per_page;
      if (regFinal > this.paginacao.total) {
        regFinal = this.paginacao.total;
      }
      return regFinal;
    },

    mobile() {
      return helpers.isMobile();
    },

    ...mapGetters(["resultadoPesquisa"]),
  },

  
  methods: {
    ...mapMutations(["setResultadoPesquisa","setMensagensAlert"]),

    exibirBtnGuia(data) {
      if (
        data.item.ind_multa_quitada ||
        data.item.ind_multa_suspensa ||
        data.item.ind_multa_prescrita ||
        data.item.ind_cancelado == 1 ||
        data.item.ind_convertido == 1
      ) {
        return false;
      } else return true;
    },

    exibirInfo(data) {
      data.item.exibirInfo = !data.item.exibirInfo;
      

      if (data.item.exibirInfo) {
        this.obterDadosAoExpandir(data);
      }
    },
    
    ordenar() {
      this.ordenacao = new Ordenacao({
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        currentPage: 1,
        perPage: 0,
      });
      this.listar();
    },

    changePaginacao() {
      this.listar();
    },

    obterDataFormatoBrasil(data) {
      return helperDatas.dataBrasil(data);
    },

    obterStatusSimNao(status) {
      return status ? "Sim" : "Não";
    },

    getVariantStatus(status) {
      return status ? "dark" : "danger";
    },

    visualizar(row) {
      if (this.filtro.componente == "placaRenavam")
        this.$router.push({
          name: "ConsultaMultaDetalheView",
          query: {
            hash: row.item.hash,
            viewstateanterior: JSON.stringify(this.filtro),
          },
        });
      else {
        this.$router.push({
          name: "ConsultaMultaDetalheViewCpfCnpj",
          query: {
            hash: row.item.hash,
            viewstateanterior: JSON.stringify(this.filtro),
          },
        });
      }
    },

    async obterDadosAoExpandir(row) {
      row.item.showmanowanderley = true;
      Promise.all([this.buscarNITPorAit(row),
                   this.buscarNAPPorAit(row),
                   this.buscarLocaInfracaoCompleto(row)])
             .finally(() => {
                row.item.showmanowanderley = false;
              });
    },

    buscarNAPPorAit(row) {
      return this.$api.Multa.buscarNAP({
        hash: row.item.hash,
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              row.item.nap =
                response.data.data.numero_notificacao +
                " - " +
                this.obterDataFormatoBrasil(response.data.data.data_emissao);
            }
          }
        })
        .catch(() => {});
    },

    buscarLocaInfracaoCompleto(row) {
      return this.$api.Multa.buscarLocaInfracaoCompleto({
        hash: row.item.hash,
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            if (response.data.data.localPrincipal)
              row.item.local_infracao_completo = 
                (response.data.data.localPrincipal.tipo_logradouro_pbh ? response.data.data.localPrincipal.tipo_logradouro_pbh + ' ' : '') +
                (response.data.data.localPrincipal.nome_logradouro_pbh ? response.data.data.localPrincipal.nome_logradouro_pbh + ', ': '') +
                (response.data.data.localPrincipal.numero ? response.data.data.localPrincipal.numero + ' - ': '') +
                (response.data.data.localPrincipal.municipio.nome ? response.data.data.localPrincipal.municipio.nome : '');
            if (response.data.data.referencia.local_infracao_referencia)
              row.item.local_infracao_completo =
                row.item.local_infracao_completo +
                " - " +
                response.data.data.referencia.local_infracao_referencia;
            if (response.data.data.complementoLogradouros)
              row.item.local_infracao_completo =
                row.item.local_infracao_completo +
                " - " +
                response.data.data.complementoLogradouros;
          }
        })
        .catch(() => {});
    },

    buscarNITPorAit(row) {
      return this.$api.Multa.buscarNIT({
        hash: row.item.hash,
      })
        .then(async (response) => {
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              row.item.nit =
                response.data.data.numero_notificacao +
                " - " +
                this.obterDataFormatoBrasil(response.data.data.data_emissao);
            }
          }
        })
        .catch(() => {});
    },

    cpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      let listaCpfCnpj = [];
      listaCpfCnpj.push(this.$store.getters.userInfo.preferred_username);
      if (result.length > 0) {
        result.forEach((element) => {
          listaCpfCnpj.push(element.substring(25, 11));
        });
      }
      return listaCpfCnpj;
    },

    emitirGuia(row) {

      if(row.item.ind_multa_divida_ativa == true) 
      {
        window.open('https://servicos.pbh.gov.br/servicos/i/5fa3f72d0ceeee0a7e69ad9a/5dc8470253fd6b5bbd99185f/servicos+guias-multa-de-transito-inscritas-em-divida-ativa', 'mozillaTab');
        return;
      }

      row.item.showAlert = false;
      row.item.listaErroGuia = [];

      let cpfCnpj = this.cpfCnpf();

      this.$api.Multa.downloadGuiaAit({ hash: row.item.hash, ohnpw: cpfCnpj })
        .then((response) => {
          if (response.status == 200) {
            if (this.mobile) {
              var a = document.createElement("a");
              a.href =
                "data:application/pdf;base64," + response.data.data.content;
              a.download = response.data.data.filename;
              a.click();
            } else {
              var tipoResource = "pdf";
              var imgMidia =
                "data:application/pdf;base64," + response.data.data.content;
              this.$emit("abrirModal", tipoResource, imgMidia);
            }
          }
        })
        .catch((error) => {
          row.item.showAlert = true;
          error.response.data.errors.forEach((element) => {
            row.item.listaErroGuia.push(element);
          });
        });
    },

    listar() {
      this.carregado = false;
      this.setResultadoPesquisa({});

      this.$refs.recaptchaRef
          .readyRecaptcha()
          .then((response) => {
            const parametros = {
              //paginacao: this.paginacao,
              ordenacao: this.ordenacao,
              filtro: new FiltroMulta(this.filtro),
              token_recaptcha: response
            };

            this.$api.Multa.listar(parametros)
              .then((response) => {
                if (response.data.success) {
                 
                  this.tabela.itens = [];
                  this.paginacao = new Paginacao();
                  this.paginacao.total = response.data.data.length;
                  response.data.data.forEach((element) => {
                    element.showmanowanderley = false;
                    element.descricao_infracao_completa = element.descricao_infracao;
                    element.descricao_infracao = element.descricao_infracao.length > 40
                                               ? element.descricao_infracao.substr(0, 40) + "..."
                                               : element.descricao_infracao;
                    element.exibirInfo = false;
                    element.listaErroGuia = [];
                    element.local_infracao_completo = "";
                    element.showAlert = false;
                    this.tabela.itens.push(element);
                  });
                  this.setResultadoPesquisa({
                    itens: this.tabela.itens,
                    paginacao: this.paginacao,
                  });                  
                  this.carregado = true;
                }
              });
          })
          .catch((erro) => {
             this.setMensagensAlert(erro);
          });
    },

    excel() {
      const parametros = {
        paginacao: this.paginacao,
        ordenacao: this.ordenacao,
        filtro: new FiltroMulta(this.filtro),
      };
      var fileDownload = require("js-file-download");
      this.$api.Multa.excel(parametros).then((response) => {
        fileDownload(
          response.data,
          "multas_" + moment().format("YYYYMMDDHHmm") + ".xlsx"
        );
      });
    },

    setResultadoDefault() {
      if (
        Object.prototype.hasOwnProperty.call(this.resultadoPesquisa, "itens")
      ) {
        if (
          this.resultadoPesquisa &&
          Object.keys(this.resultadoPesquisa.itens).length > 0
        ) {
          this.paginacao = new Paginacao(this.resultadoPesquisa.paginacao);
          this.tabela.itens = JSON.parse(
            JSON.stringify(this.resultadoPesquisa.itens)
          );
          this.$emit("alterarExibicaoResultado");
        }
      }
    },
  },

  created() {
    this.setResultadoDefault();
  },
};
</script>

<style scoped>
.total-registros {
  background-image: none !important;
  background-color: white !important;
}
</style>